import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      // 保全受理
      path: '/',
      name: 'accept',
      meta: {
        menu: '/',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/accept'], resolve)
    },
    {
      // 新建受理-申请信息,
      path: '/acceptDetail/:step',
      name: 'acceptDetail',
      meta: {
        menu: '/'
      },
      component: resolve => require(['@/pages/accept/detail'], resolve)
    },
    {
      // 保全录入
      path: '/pendingEntryList',
      name: 'PendingEntryList',
      meta: {
        menu: '/pendingEntryList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/pending'], resolve)
    },
    {
      path: '/apply',
      name: 'Apply',
      meta: {
        menu: '/pendingEntryList'
      },
      component: resolve => require(['@/pages/pending/detail'], resolve)
    },
    {
      // 保全审核
      path: '/checklist',
      name: 'Checklist',
      meta: {
        menu: '/checklist',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/audit'], resolve)
    },
    {
      // 审核详情
      path: '/check',
      name: 'Check',
      meta: {
        menu: '/checklist'
      },
      component: resolve => require(['@/pages/audit/detail'], resolve)
    },
    {
      // 人工核保
      path: '/underwriteList',
      name: 'UnderwriteList',
      meta: {
        menu: '/underwriteList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/underwrite'], resolve)
    },
    {
      // 人工核保详情
      path: '/underwriteDetail',
      name: 'UnderwriteDetail',
      meta: {
        menu: '/underwriteList'
      },
      component: resolve => require(['@/pages/underwrite/detail'], resolve)
    },
    {
      // 保全查询
      path: '/endorseQueryList',
      name: 'EndorseQueryList',
      meta: {
        menu: '/endorseQueryList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/endorseQuery'], resolve)
    },
    {
      // 保全查询详情
      path: '/endorseDetail',
      name: 'EndorseDetail',
      meta: {
        menu: '/endorseQueryList'
      },
      component: resolve => require(['@/pages/endorseQuery/detail'], resolve)
    },
    {
      // 保全打印
      path: '/endorsePrintlist',
      name: 'EndorsePrintlist',
      meta: {
        menu: '/endorsePrintlist',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/print'], resolve)
    },
    {
      // pdf预览
      path: '/endorsePrintPreview/:endorseId',
      name: 'EndorsePrintPreview',
      meta: {
        menu: '/endorsePrintlist'
      },
      component: resolve => require(['@/pages/print/detail'], resolve)
    },
    {
      // 保全项目配置
      path: '/endorseItemConfigurateList',
      name: 'EndorseItemConfigurateList',
      meta: {
        menu: '/endorseItemConfigurateList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/config'], resolve)
    },
    {
      // 新增保全配置
      path: '/addEndorseConfiguration',
      name: 'AddEndorseConfiguration',
      meta: {
        menu: '/endorseItemConfigurateList'
      },
      component: resolve => require(['@/pages/config/detail'], resolve),
    },
    // 批单录入-列表
    {
      path: '/requestPolicyApply',
      name: 'requestPolicyApply',
      meta: {
        menu: '/requestPolicyApply',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/requestPolicyApply'], resolve)
    },
    // 批单录入-详情
    {
      path: '/groupChangePolicyDetails',
      name: 'groupChangePolicyDetails',
      meta: {
        menu: '/requestPolicyApply'
      },
      component: resolve => require(['@/pages/requestPolicyApply/detail'], resolve)
    },
    // 批单录入-新单录入
    {
      path: '/insuredOperation/:step',
      name: 'insuredOperation',
      meta: {
        menu: '/requestPolicyApply'
      },
      component: resolve => require(['@/pages/requestPolicyApply/insuredOperation'], resolve)
    },
    {
      // 批单审核列表
      path: '/changePolicyApply',
      name: 'ChangePolicyApply',
      meta: {
        menu: '/changePolicyApply',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/changePolicyApply'], resolve)
    },
    {
      // 批单审核详情
      path: '/changePolicyApplyDetails',
      name: 'ChangePolicyApplyDetails',
      meta: {
        menu: '/changePolicyApply'
      },
      component: resolve => require(['@/pages/changePolicyApply/detail'], resolve)
    },
    {
      // 被保人清单打印列表
      path: '/insuredPrint',
      name: 'insuredPrint',
      meta: {
        menu: '/insuredPrint',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/insuredPrint'], resolve)
    },
    {
      // 被保人清单打印PDF
      path: '/insuredPrintPDF',
      name: 'insuredPrintPDF',
      meta: {
        menu: '/insuredPrint'
      },
      component: resolve => require(['@/pages/insuredPrint/detail'], resolve)
    },
    {
      // 被保人清单打印管理
      path: '/insuredPrintManage',
      name: 'insuredPrintManage',
      meta: {
        menu: '/insuredPrintManage',
        keep: true
      },
      component: resolve => require(['@/pages/insuredPrintManage'], resolve)
    },
    {
      // 被保人清单打印管理-打印查询
      path: '/insuredPrintManageSearch',
      name: 'insuredPrintManageSearch',
      meta: {
        menu: '/insuredPrintManage',
        keep: true
      },
      component: resolve => require(['@/pages/insuredPrintManage/search'], resolve)
    },
    {
      // 被保人清单打印管理-PDF页
      path: '/insuredPrintPDFManage',
      name: 'insuredPrintPDFManage',
      meta: {
        menu: '/insuredPrintManage'
      },
      component: resolve => require(['@/pages/insuredPrintManage/detail'], resolve)
    },
    {
      // 批单打印列表
      path: '/changePolicyPrint',
      name: 'ChangePolicyPrint',
      meta: {
        menu: '/changePolicyPrint',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/changPrint'], resolve)
    },
    {
      // 批单打印PDF
      path: '/changePolicyPrintPDF',
      name: 'ChangePolicyPrintPDF',
      meta: {
        menu: '/changePolicyPrint'
      },
      component: resolve => require(['@/pages/changPrint/detail'], resolve)
    },
    {
      // 批单打印管理
      path: '/changePolicyPrintManage',
      name: 'changePolicyPrintManage',
      meta: {
        menu: '/changePolicyPrintManage',
        keep: true
      },
      component: resolve => require(['@/pages/changePolicyPrintManage'], resolve)
    },
    {
      // 批单打印管理-打印查询
      path: '/changePolicyPrintManageSearch',
      name: 'changePolicyPrintManageSearch',
      meta: {
        menu: '/changePolicyPrintManage',
        keep: true
      },
      component: resolve => require(['@/pages/changePolicyPrintManage/search'], resolve)
    },
    {
      // 批单打印管理-PDF页
      path: '/changePolicyPrintPDFManage',
      name: 'changePolicyPrintPDFManage',
      meta: {
        menu: '/changePolicyPrintManage'
      },
      component: resolve => require(['@/pages/changePolicyPrintManage/detail'], resolve)
    },
    {
      // 批单查询列表
      path: '/changePolicyQuery',
      name: 'ChangePolicyQuery',
      meta: {
        menu: '/changePolicyQuery',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/changeQuery'], resolve)
    },
    {
      // 批单查询详情
      path: '/changePolicyQueryDetails',
      name: 'ChangePolicyQueryDetails',
      meta: {
        menu: '/changePolicyQuery'
      },
      component: resolve => require(['@/pages/changeQuery/detail'], resolve)
    },
    {
      // 影像管理
      path: '/changeAttachmentManage',
      name: 'changeAttachmentManage',
      meta: {
        menu: '/changeAttachmentManage',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/changeAttachmentManage'], resolve)
    },
    {
      // 影像管理
      path: '/changeAttachmentManageDetails',
      name: 'changeAttachmentManageDetails',
      meta: {
        menu: '/changeAttachmentManage'
      },
      component: resolve => require(['@/pages/changeAttachmentManage/detail'], resolve)
    },
    {
      // 申请修改
      path: '/modifyApplyList',
      name: 'ModifyApplyList',
      meta: {
        menu: '/modifyApplyList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/modifyApply'], resolve)
    },
    {
      // 申请信息
      path: '/applyInfo',
      name: 'ApplyInfo',
      meta: {
        menu: '/modifyApplyList'
      },
      component: resolve => require(['@/pages/modifyApply/edit'], resolve)
    },
    {
      // 修改信息
      path: '/modifyInfo',
      name: 'ModifyInfo',
      meta: {
        menu: '/modifyApplyList'
      },
      component: resolve => require(['@/pages/modifyApply/detail'], resolve)
    },
    {
      // 修改审核
      path: '/modifyCheckList',
      name: 'ModifyCheckList',
      meta: {
        menu: '/modifyCheckList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/modifyCheck'], resolve)
    },
    {
      // 修改审核详情
      path: '/modifyCheckDetail',
      name: 'ModifyCheckDetail',
      meta: {
        menu: '/modifyCheckList'
      },
      component: resolve => require(['@/pages/modifyCheck/detail'], resolve)
    },
    {
      // 修改查询
      path: '/modifyQueryList',
      name: 'ModifyQueryList',
      meta: {
        menu: '/modifyQueryList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/modifyQuery'], resolve)
    },
    {
      // 修改查询详情
      path: '/modifyQueryDetail',
      name: 'ModifyQueryDetail',
      meta: {
        menu: '/modifyQueryList'
      },
      component: resolve => require(['@/pages/modifyQuery/detail'], resolve)
    },
    {
      // 保单分配-分配申请
      path: '/policyAllocationApply',
      name: 'policyAllocationApply',
      meta: {
        menu: '/policyAllocationApply',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/policyAllocationApply'], resolve)
    },
    {
      // 分配申请详情
      path: '/policyAllocationApplyDetails',
      name: 'policyAllocationApplyDetails',
      meta: {
        menu: '/policyAllocationApply',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/policyAllocationApply/detail'], resolve)
    },
    {
      // 新建申请详情
      path: '/policyAllocationApplyCreate',
      name: 'policyAllocationApplyCreate',
      meta: {
        menu: '/policyAllocationApply'
      },
      component: resolve => require(['@/pages/policyAllocationApply/create'], resolve)
    },
    {
      // 分配审核
      path: '/policyAllocationAudit',
      name: 'policyAllocationAudit',
      meta: {
        menu: '/policyAllocationAudit',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/policyAllocationAudit'], resolve)
    },
    {
      // 分配审核详情
      path: '/policyAllocationAuditDetails/:applyId',
      name: 'policyAllocationAuditDetails',
      meta: {
        menu: '/policyAllocationAudit'
      },
      component: resolve => require(['@/pages/policyAllocationAudit/detail'], resolve)
    },
    {
      // 分配查询
      path: '/policyAllocationQuery',
      name: 'policyAllocationQuery',
      meta: {
        menu: '/policyAllocationQuery',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/policyAllocationQuery'], resolve)
    },
    {
      // 分配查询详情
      path: '/policyAllocationQueryDetails/:id',
      name: 'policyAllocationQueryDetails',
      meta: {
        menu: '/policyAllocationQuery'
      },
      component: resolve => require(['@/pages/policyAllocationQuery/detail'], resolve)
    },
    {
      // 分单申请
      path: '/singleApplication',
      name: 'SingleApplication',
      meta: {
        menu: '/singleApplication',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/singleApplication'], resolve)
    },
    {
      // 分单申请详情
      path: '/singleApplicationDetails',
      name: 'SingleApplicationDetails',
      meta: {
        menu: '/singleApplication'
      },
      component: resolve => require(['@/pages/singleApplication/detail'], resolve)
    },
    {
      // 分单审核
      path: '/singleAuditing',
      name: 'SingleAuditing',
      meta: {
        menu: '/singleAuditing',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/singleAuditing'], resolve)
    },
    {
      // 分单审核详情
      path: '/singleAuditingDetails/:applyId',
      name: 'SingleAuditingDetails',
      meta: {
        menu: '/singleAuditing'
      },
      component: resolve => require(['@/pages/singleAuditing/detail'], resolve)
    },
    {
      // 分单查询
      path: '/SingleQuery',
      name: 'SingleQuery',
      meta: {
        menu: '/SingleQuery',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/singleQuery'], resolve)
    },
    {
      // 分单查询详情
      path: '/singleQueryDetails/:id',
      name: 'SingleQueryDetails',
      meta: {
        menu: '/SingleQuery'
      },
      component: resolve => require(['@/pages/singleQuery/detail'], resolve)
    },
    {
      // 分配申请
      path: '/servicePersonAssignmentApply',
      name: 'servicePersonAssignmentApply',
      meta: {
        menu: '/servicePersonAssignmentApply',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/serviceApply'], resolve)
    },
    {
      // 分配申请详情
      path: '/servicePersonAssignmentApplyDetails',
      name: 'servicePersonAssignmentApplyDetails',
      meta: {
        menu: '/servicePersonAssignmentApply',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/serviceApply/detail'], resolve)
    },
    {
      // 新建申请详情
      path: '/servicePersonAssignmentApplyCreate',
      name: 'servicePersonAssignmentApplyCreate',
      meta: {
        menu: '/servicePersonAssignmentApply'
      },
      component: resolve => require(['@/pages/serviceApply/create'], resolve)
    },
    {
      // 分配审核
      path: '/servicePersonAssignmentAudit',
      name: 'servicePersonAssignmentAudit',
      meta: {
        menu: '/servicePersonAssignmentAudit',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/serviceCheck'], resolve)
    },
    {
      // 分配审核详情
      path: '/servicePersonAssignmentAuditDetails/:applyId',
      name: 'servicePersonAssignmentAuditDetails',
      meta: {
        menu: '/servicePersonAssignmentAudit'
      },
      component: resolve => require(['@/pages/serviceCheck/detail'], resolve)
    },
    {
      // 分配查询
      path: '/servicePersonAssignmentQuery',
      name: 'servicePersonAssignmentQuery',
      meta: {
        menu: '/servicePersonAssignmentQuery',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/serviceQuery'], resolve)
    },
    {
      // 分配查询详情
      path: '/servicePersonAssignmentQueryDetails/:id',
      name: 'servicePersonAssignmentQueryDetails',
      meta: {
        menu: '/servicePersonAssignmentQuery'
      },
      component: resolve => require(['@/pages/serviceQuery/detail'], resolve)
    },
    /** 关联保单, 保单详情 **/
    {
      // 关联保单详情  ---保全录入 ---新增
      path: '/relatePolicyInput',
      meta: {
        menu: '/pendingEntryList'
      },
      component: resolve => require(['@/pages/brindPolicy'], resolve)
    },
    {
      // 关联保单详情   ---保全审核 ---新增
      path: '/relatePolicyAudit',
      meta: {
        menu: '/checklist'
      },
      component: resolve => require(['@/pages/brindPolicy'], resolve)
    },
    {
      // 关联保单详情  ---人工核保 ---新增
      path: '/relatePolicyUnder',
      meta: {
        menu: '/underwriteList'
      },
      component: resolve => require(['@/pages/brindPolicy'], resolve)
    },
    {
      // 关联保单详情  ---保全查询
      path: '/relatePolicyDetail',
      meta: {
        menu: '/endorseQueryList'
      },
      component: resolve => require(['@/pages/brindPolicy'], resolve)
    },

    /** 保全历史信息， 保全信息 **/
    {
      // 保全信息  ---保全录
      path: '/endorseHistoryInput',
      meta: {
        menu: '/pendingEntryList'
      },
      component: resolve => require(['@/pages/endorseHistory'], resolve)
    },
    {
      // 保全信息  ---保全审核
      path: '/endorseHistoryAudit',
      meta: {
        menu: '/checklist'
      },
      component: resolve => require(['@/pages/endorseHistory'], resolve)
    },
    {
      // 保全信息  ---人工核保
      path: '/endorseHistoryUnder',
      meta: {
        menu: '/underwriteList'
      },
      component: resolve => require(['@/pages/endorseHistory'], resolve)
    },
    {
      // 保全信息  ---保全查询
      path: '/endorseHistoryDetail',
      meta: {
        menu: '/endorseQueryList'
      },
      component: resolve => require(['@/pages/endorseHistory'], resolve)
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js